import React, { useEffect } from "react";
import "./Industry_Experts.css";
import { useDispatch, useSelector } from "react-redux";
import { AllIndustryExperts } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

// ✅ Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Autoplay } from "swiper/modules";

const Industry_Experts = () => {
  const dispatch = useDispatch();
  const mentors = useSelector((state) => state?.common?.all_industry_experts);

  useEffect(() => {
    dispatch(AllIndustryExperts());
  }, [dispatch]);

  return (
    <section className="Industry_Experts">
      <div className="container">
        <div className="Industry_Experts_header">
          <div className="header_div">
            <h5 className="Industry_Experts_title">
              Industry Experts Who{" "}
              <span className="expert_span"> Lead Your Learning </span>
            </h5>

            <p className="expert_subtitle">
              Get guidance from professionals with real-world experience at top
              tech companies.
            </p>
          </div>

          <div className="title_img">
            <img
              src="/assets/images/home/industry-experts/title-img.png"
              alt="title"
              className="title_img"
            />
          </div>
        </div>

        {/* ✅ Swiper Slider */}
        <div className="expert_team_div">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: { slidesPerView: 2 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {mentors?.map((member) => (
              <SwiperSlide key={member.id}>
                <div className="member_wrapper">
                  <div className="expert_img_holder">
                    <img
                      src={`${IDS.IMG_URL}${member.image}`}
                      alt={member.name}
                      className="expert_img"
                    />
                  </div>

                  <div className="expert_info_section">
                    <div className="expert_div">
                      <p className="expert_name">{member.name}</p>

                      {member.social_links &&
                        member.social_links.icon && (
                          <div className="social_div">
                            <a
                              href={member.social_links.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={`${IDS.IMG_URL}${member.social_links.icon}`}
                                alt={member.social_links.name}
                                className="social_icon"
                              />
                            </a>
                          </div>
                        )}
                    </div>

                    <div className="desg_holder">
                      <p className="designation">
                        {member.education}
                      </p>

                      <div className="company_logo_div">
                        <img
                          src={`${IDS.IMG_URL}${member.companylogo}`}
                          alt="logo"
                          className="company_logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Industry_Experts;